import * as React from 'react';

import { PasswordResetPage } from '~src/authentication/components/PasswordResetPage';

import { DefaultServerTitleWrapper } from './DefaultServerTitleWrapper';

export const RequestPasswordResetProvider = (): JSX.Element => {
  return(
    <DefaultServerTitleWrapper>
      <div>
        <PasswordResetPage />
      </div>
    </DefaultServerTitleWrapper>
  );
};
